export const FETCH_PROJECTS = 'project/FETCH_PROJECTS';
export const FETCH_PROJECT = 'project/FETCH_PROJECT';
export const PUSH_PROJECT = 'project/PUSH_PROJECT';
export const FETCH_PROJECT_CAUSE = 'project/PUSH_PROJECT';
